/**
 * List Schema of Alerta
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Alerta} from '@/model/resource/Alerta'

/* TODO: review generated schema */
export class ListAlertaSchema extends Schema {
  readonly name = 'ListAlerta'

  readonly fieldSet: FieldSet<Alerta> = {
    idAlertaPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    descricao: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
